import { ChatMember } from '../../../../../teams-call';
import { ChatBubble } from '../../model/chat-bubble.model';

export function filterQuotesByParticipants(
    participants: ChatMember[] | null,
    quotes: ChatBubble[],
): ChatBubble[] {
    if (participants == null || participants.length === 0) {
        return [...quotes];
    }

    return quotes.filter((q) => {
        return participants.some((e) => {
            return (
                (e.msftUserId != null && e.msftUserId === q.msftUserId) ||
                e.msftDisplayName?.toLowerCase() ===
                    q.msftDisplayName?.toLowerCase()
            );
        });
    });
}
